import { makeStyles } from '@mui/styles';

export const usePVStyles = makeStyles((theme) => ({
  video: {
    width: '100%',
    height: '100%',
  },
}));
